import type { ExperienceFlattened } from '@thesavingsgroup/experience-configuration';
import { Logger } from '@thesavingsgroup/logger/Logger';

declare global {
  interface Window {
    dataLayer: unknown[];
  }
}

export const useAnalytics = (
  logger = new Logger(),
  dataLayer = window.dataLayer || [],
) => {
  /**
   * When the customer lands on the page
   */
  const sendLandedWithParamters = (
    location: Location,
    experience: ExperienceFlattened | null,
  ): void => {
    logger.info('[RATE_CALCULATOR] LandedWithParameters', {
      url: location.href,
      urlHost: location.host,
      urlPathname: location.pathname,
      ...experience,
    });

    dataLayer.push({
      event: 'LandedWithParameters',
      url: location.href,
      urlHost: location.host,
      urlPathname: location.pathname,
      ...experience,
    });
  };

  /**
   * When the customer requests rates for the first time
   */
  const sendSubmittedRateCalcOffer = (
    params?: Record<string, unknown>,
  ): void => {
    logger.info('[RATE_CALCULATOR] submittedRateCalcOffer', params);
    dataLayer.push({ event: 'submittedRateCalcOffer', ...params });
  };

  /**
   * When the customer requests rates after updating inputs
   */
  const sendUpdatedRateCalcOffer = (params?: Record<string, unknown>): void => {
    logger.info('[RATE_CALCULATOR] updatedRateCalcOffer', params);
    dataLayer.push({ event: 'updatedRateCalcOffer', ...params });
  };

  /**
   * When the customer clicks the "View details" button
   */
  const sendSelectedRateCalcOffer = (
    params?: Record<string, unknown>,
  ): void => {
    logger.info('[RATE_CALCULATOR] selectedRateCalcOffer', params);
    dataLayer.push({ event: 'selectedRateCalcOffer', ...params });
  };

  return {
    sendLandedWithParamters,
    sendSubmittedRateCalcOffer,
    sendUpdatedRateCalcOffer,
    sendSelectedRateCalcOffer,
  };
};
